import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { INCOMPLETE, PENDING_VALIDATION, VALIDATED } from 'rpqs/constants/RpqsConstant'

import { Box, Chip, ClickAwayListener, IconButton, List, ListItem, ListItemButton, Paper, Typography } from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

const ChipListItem = ({
    selectedStatus,
    setStatus = () => {},
}) => {
    const { color, name } = selectedStatus

    return (
        <ListItem disablePadding>
            <ListItemButton
                onClick={ () => setStatus(selectedStatus)}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <CircleIcon
                        fontSize='small'
                        sx={{
                            color,
                        }}
                    />
                    <Typography>{i18n[name]}</Typography>
                </Box>
            </ListItemButton>
        </ListItem>
    )
}

ChipListItem.propTypes = {
    selectedStatus: PropTypes.shape({
        name: PropTypes.string,
        color: PropTypes.string,
        bgColor: PropTypes.string,
    }),
    setStatus: PropTypes.func,
}

const SelectChipIndicator = ({
    indicatorStatus = INCOMPLETE,
    right=false,
    onChange=() => {},
    options = [VALIDATED, PENDING_VALIDATION, INCOMPLETE],
    readOnly=false,
}) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const [status, setStatus] = useState(indicatorStatus?.name ? indicatorStatus : INCOMPLETE)

    useEffect(() => {
        if (!readOnly) onChange(status)
    }, [status])

    useEffect(() => {
        setStatus(indicatorStatus?.name ? indicatorStatus : INCOMPLETE)
    }, [indicatorStatus])

    const handleExpand = () => {
        setIsExpanded(!isExpanded)
    }

    const { color, bgColor, name } = status
    return (

        <Box
            onClick={!readOnly && handleExpand}
            style={{
                paddingTop: 4,
                paddingBottom: 4,
                position: 'relative',
                width: 'max-content',
                cursor: readOnly ? 'default' : 'pointer',
            }}
        >
            <Chip
                label={<Typography>{i18n[name]}</Typography>}
                icon={<CircleIcon color={color} sx={{ fontSize: 12 }}/>}
                deleteIcon={!readOnly && (
                    <IconButton>
                        {isExpanded ?
                            <ExpandLessIcon/> :
                            <ExpandMoreIcon/>
                        }
                    </IconButton>
                )}
                onDelete={!readOnly && handleExpand}
                sx={{
                    backgroundColor: bgColor,
                    height: 'auto',
                    color,
                    px: '6px',
                    py: '3px',
                    '& .MuiChip-deleteIcon': {
                        color,
                    },
                }}
            />

            {!readOnly && isExpanded &&
                <ClickAwayListener onClickAway={() => setIsExpanded(false)}>
                    <Paper
                        sx={{
                            position: 'absolute',
                            backgroundColor: 'white',
                            zIndex: 10,
                            top: 42,
                            right: right ? 0 : undefined,
                        }}
                    >
                        <List
                            sx={{
                                width: 'max-content',
                            }}
                        >
                            {options.map((statusConst) => (
                                <ChipListItem
                                    key={statusConst.name}
                                    selectedStatus={statusConst}
                                    setStatus={setStatus}
                                />
                            ))}
                        </List>
                    </Paper>
                </ClickAwayListener>
            }
        </Box>
    )
}

SelectChipIndicator.propTypes = {
    indicatorStatus: PropTypes.shape({
        name: PropTypes.string,
        color: PropTypes.string,
        bgColor: PropTypes.string,
    }),
    right: PropTypes.bool,
    onChange: PropTypes.func,
    options: PropTypes.shape([]),
    readOnly: PropTypes.bool,
}

export default SelectChipIndicator